import { service } from '@/ajax/request'

export const dataStoreDetection = (params: any) => (
    service({
        url: '/user/userMemberDetection/storeDetection',
        method: 'POST',
        params,
    })
)

export const dataStoreDetectionCount = (params: any) => (
    service({
        url: '/user/userMemberDetection/storeCountDetection',
        method: 'POST',
        params,
    })
)

export const dataStoreRecuperate = (params: any) => (
    service({
        url: '/pms/pmsProductExpend/storeData',
        method: 'POST',
        params,
    })
)

export const dataStoreMerchant = (params: any) => (
    service({
        url: '/prescription/merchant/merchantDeviceDetails',
        method: 'POST',
        params,
    })
)